import type { PageKey } from "../../appNavTypes";

/**
 * **WHICH SCREENS CARRY THE PLAYER BAR — the lobbies, and the TILLS.**
 *
 * The bar answers three things at a glance: who am I, what can I spend, and how do I act on it.
 * That makes the rule "every screen where a player spends or is about to", not "every lobby" —
 * and Skills is what proved the difference. It is the game's shop, it prices all sixteen skills
 * in Soul Shards and Suika, and it shipped with no bar at all: no name, no pooled shard balance,
 * and no way to move Trainer Suika onto the Suikamon whose shelf was open without leaving the
 * page for it.
 *
 * **NEVER INSIDE A LIVE BATTLE.** The arena is the one screen that stays undistracted; both
 * battle pages carry their own comment saying so.
 *
 * Its own module rather than a `const` inside `GameShell`, because a component file that also
 * exports data breaks Fast Refresh — and because this list is a decision, pinned by
 * `__tests__/playerBarPages.test.ts`, rather than an implementation detail of a layout.
 */
export const PLAYER_BAR_PAGES: PageKey[] = [
  "play",
  "play-free",
  "campaign",
  "pvp-trial",
  "pvp-ranked",
  "pvp-squad-ranked",
  "pvp-lab",
  "pet-cards",
];
